<template>
    <div class="container container--narrow pdt-50 pdb-26"  >
        <div class="pdt-50 t-center pdb-24" v-if="!certificatesData.length">
            <img src="/img/no-register.svg" alt="" class="icon62 mgx-auto mgb-24">
            <div class="t-body1 t-center font-r t-color-bodyGrayA">{{$t('696')}}</div>
        </div>
        <!-- </div>
        <div class="container container--narrow pdt-30"> -->
        <template v-if="certificatesData.length"  >
            <div class="mdc-card  mgb-24 pdb-8" v-for="(certificate, index) in certificatesData" :key="index">
                <div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('695')}}</div>
                <div class="pdl-24 pdr-24 pdt-16 pdb-16">
                    <div class="d-flex align-items-center">
                        <img src="/img/certificate-icon.svg" alt="" class="w-52 h-52 min-w-52">
                        <div class="t-body1 font-r t-color-bodyGrayA pdl-20 l-spacing48 flex-grow-1">{{certificate.name}}
                        </div>
                    </div>

                </div>
            </div>
        </template>

    </div>
    

</template>


<script>
/**
 * 차수 상세 인증서 탭 컴포넌트(degree view certification tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'
import NoData from "../../common/NoDataCertificateDegree.vue";
export default {
    data() {
        return {
            certificatesData: [],
        }
    },
    components: {
        NoData,
    },
    mounted() {
        this.fetchData()
    },

    methods: {
        // 인증서 API 호출 및 데이터 설정(call api data)
        fetchData() {
            let responseData = null
            let params = this.setParams()

            degreeApi.guestLearnOnlineViewCertificates(params).then((response) => {
                this.certificatesData = response.data.data
            }).catch((err) => {})
        },
        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId
            }
            return params
        },
    }

}
</script>